

const ComponentCard = ({children}) => {
  return (
    <div className='bg-white shadow-md mb-3 p-1 md:p-3 rounded-md '>
      {children}
    </div>
  );
};

export default ComponentCard;